import Vue from 'vue';
import moment from 'moment';

// 注册filter
Vue.filter('filter-empty', function (value) {
    return value ? value : '-';
})

Vue.filter('date-format', function (value, format) {
    if (!value) {
        return '-';
    }
    return Number(value) ? moment(value, 'X').format(format ? format : 'YYYY-MM-DD HH:mm') : value;
})

Vue.filter('sec-to-hour', function (value) {
    let h = parseInt(value / 60 / 60);
    let m = parseInt(value / 60 % 60);
    let s = parseInt(value % 60);
    return Number(value) ? [
        h > 0 ? h + 'h' : '',
        m > 0 ? m + 'm' : '',
        s + 's'
    ].join('') : value;
})

Vue.filter('url-proto', function (value) {
    const ossHost = 'mmc-forecast.oss-cn-shanghai.aliyuncs.com';
    const cdnHost = 'img-fe.tengzhihh.com';
    let tmpStr = '';
    if (value) {
        tmpStr = value.replace('http://', 'https://');
        tmpStr = tmpStr.replace(ossHost, cdnHost);
    }
    return tmpStr;
})

Vue.filter('req-weight-tips', function (value) {
    let A_percent = value;
    let B_percent = 100 - value;
    let middleNode = Math.round(256 * (A_percent / 100));
    let A_interval = middleNode > 0 ? `（ ip网段：0 ~ ${middleNode - 1} ）` : '';
    let B_interval = middleNode < 255 ? `（ ip网段：${middleNode} ~ 255 ）` : '';
    return `${A_percent}%流量${A_interval}将被分配到链接A，${B_percent}%流量${B_interval}将被分配到链接B`;
});

Vue.filter('url-to-https', function (value) {
    return value ? value.replace('http://', 'https://') : value;
})

Vue.filter('auth-type-to-cn', function (value) {
    let str = '';
    switch(value) {
        case 1:
            str = '根节点';
            break;
        case 2:
            str = '菜单组';
            break;
        case 3:
            str = '菜单';
            break;
        case 4:
            str = '功能点';
            break;
    }
    return str;
})






// WEBPACK FOOTER //
// ./src/utils/filters.js